<template>
    <section class="grid-flex center">

        <div>
            <div class="box-content flex txt-center center">
                <div>
                    <div class="img-warning" style="margin-top: 30px">
                        <img src="@/assets/img/warning-logo.png" width="120">
                    </div>

                    <div class="margin-top-l">
                        <h2>Conta Cancelada!</h2>
                        <br>
                        <p>Sua conta foi cancelada por falta de pagamento!</p>
                        <br>
                        <p v-if="account.account_type ==='MANAGER'">Clique no botão abaixo para ativar e escolha um plano:</p>
                        <br>
                        <div 
                          v-if="account.account_type ==='MANAGER'"
                          class="button primary"
                          @click="activeAccount()"
                        >
                            Quero ATIVAR minha CONTA
                        </div>
                        <div 
                          v-if="account.account_type ==='PROJECT'"
                        >
                            A conta administrador está Cancelada. Fale com o dono da conta administradora: {{ account.account_manager_name }}
                        </div>
                        <a v-if="false" href="https://api.whatsapp.com/send?phone=5541984421134&text=Conta Cancelada" target="_blank">
                            <div class="button primary">
                                <span>(41) 98442-1134</span>
                            </div>
                        </a>

                        <div class="margin-top-l">
                            <a @click="logout()">
                                <div class="button secondary">
                                    <span>Sair</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { mapState } from "vuex";

import { Account, updateAccount } from "@/services/account";


export default {
  name: "canceled-account",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.getAccountInfo();
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    activeAccount() {
      let base_url = "https://unicotracker.com.br/escolha-seu-plano.html"
      let url = `${base_url}?freemium=true&email=${this.account && this.account.email}&phone=${this.account && this.account.phone}`

      document.location.href = url

    },
    updateAccount() {
    let params = {
      activeAccount: true,
    }
      updateAccount(params)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Sua Conta foi ativada. Faça assinatura do plano",
          });

          this.$store.dispatch("setAccount", result);
          this.$router.push({ name: "Home" });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
    logout() {
      this.$store.dispatch("logout");
      //this.$router.push({ name: "Login" });
      window.location.reload();

    },
  },
};
</script>

<style lang="scss" scoped>
</style>
